import { createFileRoute, redirect } from "@tanstack/react-router";

// Both entry routes use the same sign-in screen; new accounts accept the Terms in the portal.
export const Route = createFileRoute("/login")({
  beforeLoad: () => {
    throw redirect({ href: "/portal?auth=login" });
  },
});
